import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

const styles = StyleSheet.create({
  errorContainer: {
    backgroundColor: '#fae7ea',
    marginTop: spacing.$4,
  },
  iconContainer: {
    marginLeft: spacing.$1,
  },
  paymentSelection: {
    marginTop: spacing.$4,
    paddingBottom: spacing.$8,
  },
  totalContainer: {
    flexDirection: 'row',
    marginBottom: spacing.$3,
  },
  warningContainer: {
    marginRight: spacing.$3,
    paddingBottom: spacing.$3,
    paddingTop: spacing.$6,
  },
});

const createBox = (baseStyle: BoxProps['style']) => ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [baseStyle, style] });

export const PaymentSelection = createBox(styles.paymentSelection);

export const DisclaimerWrapper = withTypography({
  color: primitive.$greyOne,
  fontFamily: 'body',
  fontSize: 'xs',
  mt: '$0',
  mr: '$0',
  mb: '$4',
  ml: '$0',
  px: '$1',
  py: '$0',
  textAlign: 'center',
});

export const CartPriceTooLow = withTypography({
  color: getDesignToken('alert-warning-background'),
  style: {
    margin: 0,
    padding: spacing.$2,
    textAlign: 'center',
  },
});

export const StoreUnavailableMessage = withTypography({
  bold: true,
  color: primitive.$fieryRed,
  fontFamily: 'heading',
  fontSize: 'xs',
  mb: '$1',
  mx: '$0',
  textAlign: 'center',
  style: { marginTop: -8 },
});

export const ErrorContainer = createBox(styles.errorContainer);

export const ErrorMessage = withTypography({
  mx: '$8',
  my: '$0',
  px: '$0',
  color: primitive.$fieryRed,
  style: { paddingVertical: 11 },
});

export const SignUpToContinueDisclaimer = withTypography({
  color: primitive.$greyOne,
  fontSize: 'sm',
  textAlign: 'center',
  mb: '$8',
  style: { fontWeight: primitive.$fontWeightNormal },
});

export const WarningContainer = createBox(styles.warningContainer);

export const SkeletonStyled = Skeleton.withConfig({
  testID: 'currency-line-skeleton',
  height: '$4',
  width: '120px',
  alignSelf: 'center',
  color: primitive.$greyFour,
  borderRadius: 'full',
  mb: '$3',
});

export const TotalContainer = ({ focusable = true, style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, focusable, style: [styles.totalContainer, style] });

export const IconContainer = createBox(styles.iconContainer);
